import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import ProtectedRoute from "../components/ProtectedRoute";
import MiniHeader from "../components/MiniHeader";
import DashboardLayout from "../layouts/DashboardLayout";
import Login from "../modules/auth/Login";
import AllAttendance from "../pages/attendance/AllAttendance";
import MonthlyAttendance from "../pages/attendance/MonthlyAttendance";
import MyAttendance from "../pages/attendance/MyAttendance";
import UserMonthlyData from "../pages/attendance/UserMonthlyData";
import Dashboard from "../pages/dashboard/Dashboard";
import TaskDetails from "../pages/dashboard/components/TaskDetails";
import TaskDetailsMy from "../pages/dashboard/components/TaskDetailsMy";
import TeamTasks from "../pages/dashboard/components/TeamTasks";
import UserTaskBoard from "../pages/dashboard/components/UserTaskBoard";
import TeamDetailsPage from "../pages/dashboard/components/teams/TeamDetailsPage";
import TeamsPage from "../pages/dashboard/components/teams/TeamsPage";
import AllDocuments from "../pages/documents/AllDocuments";
import UploadDocuments from "../pages/documents/UploadDocuments";
import Categories from "../pages/expenses/Categories";
import AddExpense from "../pages/expenses/AddExpense";
import ExpenseList from "../pages/expenses/ExpenseList";
import Wallet from "../pages/expenses/Wallet";
import Gallery from "../pages/gallery/Gallery";
import PublicScreenshots from "../pages/gallery/PublicScreenshots";
import TrackerDownloads from "../pages/tracker/TrackerDownloads";
import GrievancePage from "../pages/grievance/GrievancePage";
import CreateUser from "../pages/employees/CreateUser";
import ApproveProfileChanges from "../pages/employees/ApproveProfileChanges";
import ApproveProfileDocuments from "../pages/employees/ApproveProfileDocuments";
import Departments from "../pages/employees/Departments";
import Employees from "../pages/employees/Employees";
import ExEmployees from "../pages/employees/ExEmployees";
import ReportingTool from "../pages/employees/ReportingTool";
import AddItem from "../pages/inventory/AddItem";
import AssignItems from "../pages/inventory/AssignItems";
import Inventory from "../pages/inventory/Inventory";
import ApplyLeave from "../pages/leaves/ApplyLeave";
import Holidays from "../pages/leaves/Holidays";
import LeavePolicy from "../pages/leaves/LeavePolicy";
import LeaveReport from "../pages/leaves/LeaveReport";
import MyLeaves from "../pages/leaves/MyLeaves";
import PendingLeaves from "../pages/leaves/PendingLeaves";
import EmployeeSalaries from "../pages/payroll/EmployeeSalaries";
import Increment from "../pages/payroll/Increment";
import Payroll from "../pages/payroll/Payroll";
import PayrollRecords from "../pages/payroll/PayrollRecords";
import Payslips from "../pages/payroll/Payslips";
import CreateFeed from "../pages/posts/CreateFeed";
import CreateAppPage from "../pages/projects/CreateAppPage";
import CreateProject from "../pages/projects/CreateProject";
import AppsListPage from "../pages/projects/AppsListPage";
import AppsMy from "../pages/projects/AppsMy";
import ProjectVideoPage from "../pages/projects/ProjectVideoPage";
import ProjectsListPage from "../pages/projects/ProjectsListPage";
import ProjectsMy from "../pages/projects/ProjectsMy";
import Profile from "../pages/profile/Profile";
import UserProfile from "../pages/profile/UserProfile";
import QuoteRequests from "../pages/quotes/QuoteRequests";
import AssignedTasks from "../pages/tasks/AssignedTasks";
import TasksPage from "../pages/tasks/TasksPage";

import ProtectedRoleElement from "./ProtectedRoleElement";
import { adminOrHrRoles, hrOnlyRoles } from "./routeRoles";

const hrOnly = (children) => (
  <ProtectedRoleElement allowedRoles={hrOnlyRoles}>{children}</ProtectedRoleElement>
);

const adminOrHr = (children) => (
  <ProtectedRoleElement allowedRoles={adminOrHrRoles}>
    {children}
  </ProtectedRoleElement>
);

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/mini" element={<MiniHeader />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />

            <Route path="user/:id" element={<TaskDetails />} />
            <Route path="users/:id" element={<UserProfile />} />
            <Route path="profile" element={<Profile />} />
            <Route path="task-details-my" element={<TaskDetailsMy />} />
            <Route path="team-task" element={<TeamTasks />} />
            <Route path="tasks/assigned" element={<AssignedTasks />} />
            <Route path="tasks/:view" element={<TasksPage />} />
            <Route path="dashboard/teams" element={<TeamsPage />} />
            <Route path="dashboard/teams/:id" element={<TeamDetailsPage />} />
            <Route path="dashboard/user-monthly-tasks/:id" element={<UserTaskBoard />} />

            <Route path="employees" element={hrOnly(<Employees />)} />
            <Route path="employees/create" element={hrOnly(<CreateUser />)} />
            <Route path="employees/profile-change-requests" element={adminOrHr(<ApproveProfileChanges />)} />
            <Route path="employees/profile-document-requests" element={adminOrHr(<ApproveProfileDocuments />)} />
            <Route path="employees/reporting" element={adminOrHr(<ReportingTool />)} />
            <Route path="employees/ex" element={hrOnly(<ExEmployees />)} />
            <Route path="departments" element={hrOnly(<Departments />)} />

            <Route path="attendance/me" element={<MyAttendance />} />
            <Route path="attendance/all" element={adminOrHr(<AllAttendance />)} />
            <Route path="attendance/monthly" element={adminOrHr(<MonthlyAttendance />)} />
            <Route path="attendance/monthly/user" element={adminOrHr(<UserMonthlyData />)} />

            <Route path="expenses" element={adminOrHr(<ExpenseList />)} />
            <Route path="expenses/add" element={adminOrHr(<AddExpense />)} />
            <Route path="expenses/wallet" element={adminOrHr(<Wallet />)} />
            <Route path="expenses/categories" element={adminOrHr(<Categories />)} />

            <Route path="leaves/apply" element={<ApplyLeave />} />
            <Route path="leaves/me" element={<MyLeaves />} />
            <Route path="leaves/policy" element={<LeavePolicy />} />
            <Route path="leaves/holidays" element={<Holidays />} />
            <Route path="leaves/pending" element={hrOnly(<PendingLeaves />)} />
            <Route path="leaves/report" element={hrOnly(<LeaveReport />)} />

            <Route path="payroll" element={hrOnly(<Payroll />)} />
            <Route path="payroll/records" element={hrOnly(<PayrollRecords />)} />
            <Route path="payroll/salaries" element={hrOnly(<EmployeeSalaries />)} />
            <Route path="payroll/payslips" element={hrOnly(<Payslips />)} />
            <Route path="payroll/increment" element={hrOnly(<Increment />)} />

            <Route path="posts/create" element={<CreateFeed />} />
            <Route path="grievance" element={<GrievancePage />} />
            <Route path="quotes/requests" element={adminOrHr(<QuoteRequests />)} />

            <Route path="upload/documents" element={<UploadDocuments />} />
            <Route path="documents/all" element={<AllDocuments />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="screenshots" element={<PublicScreenshots />} />
            <Route path="tracker" element={<TrackerDownloads />} />

            <Route path="projects/create" element={<CreateProject />} />
            <Route path="projects/all" element={<ProjectsListPage />} />
            <Route path="projects/video/:id" element={<ProjectVideoPage />} />
            <Route path="projects/my" element={<ProjectsMy />} />
            <Route path="apps/create" element={<CreateAppPage />} />
            <Route path="apps/list" element={<AppsListPage />} />
            <Route path="apps/my" element={<AppsMy />} />

            <Route path="inventory/all" element={hrOnly(<AddItem />)} />
            <Route path="inventory/add" element={hrOnly(<Inventory />)} />
            <Route path="inventory/assign" element={hrOnly(<AssignItems />)} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
